import styled from "styled-components";
import { Link } from "react-router-dom";
import Container from "../../Components/Container";
import FlexInColumn from "../../Components/FlexInColumn";
import FlexInRow from "../../Components/FlexInRow";
import PageText from "../../Components/PageText";

const Wrapper = styled.section`
  background-color: #ffffff;
  color: #ffffff;
  font-size: 1.042vw;
  letter-spacing: 0px;
  line-height: inherit;
  text-align: center;
  width: 100%;
`;

const Card = styled.div`
  background-color: #fde0cd;
  background-image: url(${(props) => props.bgImage});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  padding-top: 3.854vw;

  .card__title {
    text-align: left;
    font-size: 2.083vw;
    font-weight: bold;
    line-height: 2.5vw;
    letter-spacing: 0px;
    color: #0c1151;
    text-transform: uppercase;
    opacity: 1;
    margin: 0;
    width: 34.063vw;
  }

  .card__title.title-width {
    max-width: 400px;
  }

  .card__image {
    margin-top: auto;
  }

  .card__cta {
    background-color: #f88436;
    border-radius: 0.521vw;
    opacity: 1;
    transition: 0.3s ease;
    text-decoration: none;
    color: #ffffff;
    font-size: 1.146vw;
    font-weight: bold;
    line-height: 1.51vw;
    padding: 0.781vw 1.563vw;
    max-width: 10.833vw;
  }

  .card__cta:hover {
    background-color: #e87426;
    color: #ececec;
  }

  .card__list {
    padding-bottom: 20px;
  }

  @media (max-width: 992px) {
    .card__title {
      width: 100%;
    }

    .card__cta {
      margin: auto;
      border-radius: 2.778vw;
      font-size: 3.611vw;
      line-height: 5vw;
      padding: 2.778vw 4.167vw;
      max-width: 35.667vw;
    }
  }

  @media (min-width: 1280px) {
    .card__content {
      min-width: 36vw;
    }
  }

  @media (min-width: 1920px) {
    padding-top: 76px;

    .card__title {
      font-size: 40px;
      line-height: 48px;
    }

    .card__cta {
      border-radius: 10px;
      font-size: 22px;
      line-height: 29px;
      padding: 15px 30px;
      max-width: 238px;
    }

    .card__content {
      min-width: 654px;
    }
  }
`;

export default function PatologistaCards(props) {
  const ContentCards = [
    {
      imageBackground: require("../../Assets/Images/bg-patologista-01@2x.png"),
      title: "Professor Manuel Sobrinho Simões",
      titleWidth: true,
      subtitle:
        "Patologista do Centro Hospital S. João e do Instituto de Patologia e Imunologia Molecular da Universidade do Porto (IPATIMUP)",
      imageDesktop: require("../../Assets/Images/img-conheca-patologista-manuel.png"),
      imageMobile: require("../../Assets/Images/img-conheca-patologista-manuel.png"),
      imageAlt: "Professor Manuel Sobrinho Simões",
      link: "https://www.spap.pt/socios/perfil/manuel-simoes-590",
      topics: [
        {
          title:
            "O que distingue a Anatomia Patológica das restantes especialidades?",
          text: "A Anatomia Patológica distingue-se das outras especialidades consideradas <i>“próximas”</i> (Patologia Clínica, Genética, Microbiologia, Imunologia,…) por ocupar o espaço entre as Ciências Básicas e as Ciências Clínicas e, também, por entrar decididamente nesses dois universos. Partimos sempre dos tecidos (e às vezes das células) e caminhamos </i>“para baixo”</i> até aos genes e, <i>“para cima”</i>, até à pessoa doente. Não há outra especialidade que seja capaz de se movimentar tão bem, e com tanta competência, entre a dimensão clínica e a dimensão molecular, com benefícios para os doentes e para os outros médicos envolvidos na relação médico-doente.",
        },
        {
          title: "Qual o maior desafio para um médico anátomo-patologista?",
          text: "Não se limitar a ser um rotulador de lesões e/ou doenças. É fundamental assegurar compreensão e competência para além das classificações e das métricas. O grande desafio é continuar a aprender com a experiência e o estudo, melhorando a compreensão dos mecanismos subjacentes aos processos lesionais em articulação com a melhoria do diagnóstico, prognóstico e selecção terapêutica (autoridade técnica, profissional e social).",
        },
        {
          title:
            "Qual a mensagem para os estudantes de medicina que esteja a pensar escolher esta especialidade?",
          text: "A mensagem a passar para os estudantes tem a ver com o orgulho do anátomo-patologista ser um médico competente a vários níveis. Os anátomo-patologistas são, em conjunto com os internistas e os médicos de família, os médicos mais capazes de corresponder à ideia do médico do futuro num registo de colaboração e multidisciplinaridade. O anátomo-patologista continuará a ser o pivot do trabalho de diagnóstico (por exemplo em colaboração com a imagiologia) e do trabalho de prognóstico/selecção terapêutica (em colaboração com médicos de várias especialidades no âmbito, por exemplo, dos grupos oncológicos).",
        },
      ],
    },
    {
      imageBackground: require("../../Assets/Images/bg-patologista-02@2x.png"),
      title: "Professor Vitor Sousa",
      subtitle:
        "Patologista do Centro Hospitalar e Universitário de Coimbra e do Instituto de Anatomia Patológica e Patologia Molecular da Faculdade de Medicina da Universidade de Coimbra.",
      imageDesktop: require("../../Assets/Images/img-conheca-patologista-vitor-sousa.png"),
      imageMobile: require("../../Assets/Images/img-conheca-patologista-vitor-sousa.png"),
      imageAlt: "Professor Vitor Sousa",
      link: "https://www.spap.pt/socios/perfil/vitor-sousa-673",
      topics: [
        {
          title: "Pelas suas palavras o que faz um Anatomo-Patologista:",
          text: "Um Anatomo-Patologista tem como principal função a elaboração de diagnósticos Anatomo-Patológicos, com base na interpretação de imagens macroscópicas, microscópicas (histológicas ou citológicas) em alguns casos de microscopia eletrónica, integrando ainda informações de Patologia Molecular incluindo técnicas de imunohistoquimica, FISH, sequenciação ou outras. O diagnóstico realizado permite não só diagnosticar / classificar a doença, mas também dar indicações com valor prognóstico e para a decisão terapêutica, tornando o papel do Anatomo-Patologista cada vez mais central em reuniões multidisciplinares de decisão terapêutica. São também funções de um Anatomo-Patologista a realização de autópsias Anatomo-Clínicas / Anatomo-Patológicas. Tendo em consideração que a Anatomia Patológica constitui uma ciência / disciplina charneira que fazendo uso de conhecimentos de várias ciências permite a sua integração no diagnóstico clínico, cada vez mais o Anatomo-Patologista é convidado ou é promotor ativo de projetos de investigação científica ou de ensaios clínicos.",
        },
        {
          title: "Que avanços têm ocorrido nesta área:",
          text: "Nos últimos anos têm ocorrido enormes avanços na Anatomia Patológica que têm tornado esta arte cada vez mais aliciante e desafiante. Uma das áreas de maior desenvolvimento e com potencial de crescimento é a área da Medicina Personalizada e da Patologia Molecular aplicada no diagnóstico, avaliação de prognóstico e na seleção da terapêutica mais adequada para cada doente o que tem permitido uma mudança de paradigma na Medicina, nomeadamente no contexto da Medicina de Precisão. Outra área em grande desenvolvimento e estimulante é a Patologia Digital o que permite a substituição das lâminas físicas por virtuais com ganhos na organização, produtividade e até com implicações ecológicas tendo em conta a emergência ambiental e o desígnio de poupança nomeadamente de recursos como o papel. A patologia digital permitiu que a Anatomia Patológica entrasse em força no maravilhoso mundo novo da Inteligência Artificial, quer no desenvolvimento quer na aplicação de algoritmos de inteligência artificial aplicados ao diagnóstico e investigação.",
        },
        {
          title:
            "Qual a mensagem para os estudantes de Medicina que estejam a ponderar pensar escolher esta especialidade?",
          text: "A especialidade de Anatomia Patológica é muito aliciante no sentido em que permite integrar informações de várias ciências na prática clínica ao elaborar diagnósticos anátomo-patológicos. Embora considere uma especialidade exigente, é por outro lado muito aliciante tendo em conta a grande variedade de órgãos e sistemas em que se elaboram os diagnósticos e o reconhecimento cada vez maior entre pares tendo em conta a multidisciplinariedade e papel na Medicina Personalizada. Os recentes desenvolvimentos nomeadamente na Patologia Molecular e Medicina de Precisão e na Patologia Digital e na Inteligência Artificial poderão constituir também importantes motivadores. Os Patologistas são necessários e muito requisitados. Os Patologistas estão de braços abertos para vos receber e de um modo geral muito motivados para partilhar os conhecimentos e a sua experiência, contando convosco para trilhar este caminho de desenvolvimento – serão muito bem-vindos.",
        },
        {},
      ],
    },
    {
      imageBackground: require("../../Assets/Images/bg-patologista-03@2x.png"),
      title: "Dr. António Alves",
      subtitle: "Patologista do Hospital CUF Descobertas",
      imageDesktop: require("../../Assets/Images/img-conheca-patologista-antonio-alvez.png"),
      imageMobile: require("../../Assets/Images/img-conheca-patologista-antonio-alvez.png"),
      imageAlt: "Dr. António Alves",
      link: "https://www.spap.pt/socios/perfil/antonio-alves-465",
      topics: [
        {
          title: "Porque escolheu Anatomia Patológica?",
          text: "Quando entrei para a medicina, não foi tanto pela visão romântica do Dr. João Semana. Não era para mim fundamental ter a relação médico-doente como alicerce do meu trabalho. Sempre gostei da possibilidade de trabalhar numa área abrangente em que o conhecimento das ciências básicas poderia ter um contributo para a minha atividade profissional. Aliar esse conhecimento a um trabalho com resultados práticos e fundamentais para o manejo do doente é muito gratificante. Poder trabalhar em áreas tão distintas, desde a doença inflamatória intestinal até aos sarcomas, é muito desafiante e não permite a monotonia! Saber que o relatório anatomopatológico que emitimos tem um peso tão importante, traz também um enorme sentido de responsabilidade ao nosso trabalho. Passados vários anos nesta especialidade, tenho a certeza que a voltaria a escolher.",
        },
        {
          title: "Como antevê a prática desta Especialidade daqui a 10 anos?",
          text: "Com bastante entusiasmo e alguma cautela, mas a perspetiva da <i>“evolução”</i> da especialidade é outra das razões pela qual a escolhi. Considera-se que o exercício da Anatomia Patológica terá sido das primeiras aplicações do método científico na área da medicina, nomeadamente com a realização de autópsias. Temos assistido a uma evolução fantástica nesta área, em que passamos de uma avaliação macroscópica necrópsica à determinação de alterações moleculares, específicas a cada doente, e que vão permitir terapêuticas personalizadas com melhores resultados. Nesta área vamos continuar a evoluir e o contributo do Patologista será fundamental para permitir uma melhoria no prognóstico dos doentes e (esperemos) numa redução dos custos associados à saúde. Penso que em breve vamos ter um papel, cada vez mais importante, dos sistemas de inteligência artificial (IA), que nos vão ajudar a tornar o nosso trabalho ainda mais eficiente e ajudar na manutenção dos standards de qualidade que são fundamentais para um relatório anátomo-patológico. Acredito que a digitalização e a IA vão contribuir para avaliarmos os casos de outra maneira com novos dados, para a estandardização de fatores a avaliar e otimizar a variabilidade que está associada à observação dos casos. Contudo, somos poucos Patologistas em Portugal… Nos próximos anos teremos um bom número de excelentes recém-especialistas, mas que pode não conseguir suprir os Patologistas que se vão reformar, levando consigo anos valiosos de experiência e conhecimento. Os Serviços ao ficarem mais carenciados, terão maior dificuldade em prestar uma atividade de excelência à população e na sua capacidade de formação médica.",
        },
        {
          title:
            "Qual a mensagem para os internos e estudantes de Medicina que estejam a pensar escolher esta Especialidade?",
          text: "Antes de mais, parabéns por terem colocado como hipótese a melhor especialidade médica! É verdade que perdemos o contacto com os doentes e, de certo modo, com a medicina clínica. Daí a escolha desta especialidade ser pouco <i>“natural”</i> porque temos um curso essencialmente direcionado para a prática clínica. Contudo, esta especialidade tem muitas vantagens ao servir de fronteira entre a investigação científico-médica de base e os cuidados clínicos. O trabalho do Patologista não é só avaliar casos no conforto do seu gabinete, isolado do resto do mundo (e ainda bem)! Para além dos relatórios anatomo-patológicos que emitimos diariamente, temos que prestar assistência em diversas situações. A atos cirúrgicos - exame intra-operatório - o que significa que temos de dar uma resposta imediata que vai condicionar o procedimento cirúrgico. Temos de fazer autópsias! Esta valência pode ser vista com grande entusiasmo ou algum desdém, dependendo da pessoa, mas não há outro ato médico tão integrador como este - conseguir dar uma última resposta que é fundamental para a melhoria da prática médica. Participamos em reuniões multidisciplinares em que o nosso <i>“know-how”</i> vai ajudar na decisão da melhor abordagem para cada doente. Podemos ser solicitados para realizar punções aspirativas. É o pouco contacto que temos com doentes, mas muito gratificante porque, ao contrário de outras especialidades que fazem esta técnica, nós temos a capacidade de avaliar o material no momento e decidir a melhor abordagem para um diagnóstico mais eficaz! Outro aspeto importante, depois de escolher a especialidade, é o local. Queremos uma abordagem mais generalista? mais direccionada para a patologia tumoral (IPO)? queremos trabalhar num grande centro onde temos a possibilidade de aprofundar os nossos conhecimentos em áreas específicas? ou talvez num hospital mais pequeno em que a nossa capacidade como generalista vai ser posta à prova? Felizmente, os hospitais estão muito integrados durante o internato o que significa que se pode complementar com estágios fora (até fora do país) alguma valência que possa não existir ou ser insuficiente no hospital de base. E para terminar, outra grande vantagem - não fazemos urgências! Mas isso não significa que vamos deixar de trabalhar de noite ou aos fins de semana… Somos poucos patologistas em Portugal, o que significa que há muito trabalho a fazer para que os doentes não fiquem sem os seus diagnósticos valiosos.",
        },
        {},
      ],
    },
  ];

  return (
    <Wrapper>
      <FlexInRow gap="0">
        {ContentCards.map((item, index) => {
          return (
            <Card bgImage={item.imageBackground}>
              <Container>
                <FlexInColumn gap="1.927vw" mobile="column">
                  {index % 2 === 0 ? (
                    <>
                      <FlexInRow gap="0.521vw" className="card__content">
                        <h2
                          className={
                            item.titleWidth
                              ? "card__title title-width"
                              : "card__title"
                          }
                        >
                          {item.title}
                        </h2>
                        <PageText text={item.subtitle} />
                        <picture className="card__image">
                          <source
                            srcSet={item.imageDesktop}
                            media="(min-width: 990px)"
                          />
                          <img src={item.imageMobile} alt={item.imageAlt} />
                        </picture>
                      </FlexInRow>
                      <FlexInRow gap="80px" className="card__list">
                        <Link to={item.link} className="card__cta">
                          Visitar Perfil
                        </Link>
                        <FlexInRow gap="1.042vw">
                          {item.topics.map((topic, index) => {
                            return (
                              <PageText
                                title={topic.title}
                                text={topic.text}
                                readMore={true}
                              />
                            );
                          })}
                        </FlexInRow>
                      </FlexInRow>
                    </>
                  ) : (
                    <>
                      <FlexInRow gap="80px" className="card__list">
                        <Link to={item.link} className="card__cta">
                          Visitar Perfil
                        </Link>
                        <FlexInRow gap="1.042vw">
                          {item.topics.map((topic, index) => {
                            return (
                              <PageText
                                title={topic.title}
                                text={topic.text}
                                readMore={true}
                              />
                            );
                          })}
                        </FlexInRow>
                      </FlexInRow>
                      <FlexInRow gap="0.521vw" className="card__content">
                        <h2 className="card__title">{item.title}</h2>
                        <PageText text={item.subtitle} />
                        <picture className="card__image">
                          <source
                            srcSet={item.imageDesktop}
                            media="(min-width: 990px)"
                          />
                          <img src={item.imageMobile} alt={item.imageAlt} />
                        </picture>
                      </FlexInRow>
                    </>
                  )}
                </FlexInColumn>
              </Container>
            </Card>
          );
        })}
      </FlexInRow>
    </Wrapper>
  );
}
